module.exports = __webpack_public_path__ + "static/media/Group2.103213c6.png";